import { Controller } from "@hotwired/stimulus";
import debounce from "lodash.debounce";

export default class extends Controller {
  static targets = ["form", "lineTotal", "grandTotal"];

  connect() {
    this.debouncedSubmit = debounce(this.submitCart.bind(this), 500);
  }

  updateQuantity(event) {
    try {
      const input = event.target;
      if (!event.isTrusted) return;

      const form = input.closest("form");
      if (!form.reportValidity()) {
        form.classList.add("was-validated");

        event.preventDefault();
        event.stopPropagation();
        return;
      }

      this.updateLineTotal(input);
      this.debouncedSubmit();
    } catch (error) {
      console.error("[cart]", error, {
        controller: "cart",
        action: "updateQuantity",
      });
    }
  }

  updateLineTotal(input) {
    try {
      const row = input.closest("tr");
      const td = row.querySelector("[data-cart-target='lineTotal']");

      td.innerHTML = `<div class="spinner-border spinner-border-sm text-muted"
        role="status" aria-hidden="true"></div>`;
      this.flashRow(row);
    } catch (error) {
      console.error("[cart]", error, {
        controller: "cart",
        action: "updateLineTotal",
      });
    }
  }

  flashRow(row) {
    row.classList.add("flash");
    setTimeout(() => {
      row.classList.remove("flash");
    }, 600);
  }

  submitCart() {
    try {
      this.formTarget.requestSubmit();
    } catch (error) {
      console.error("[cart]", error, {
        controller: "cart",
        action: "submitCart",
      });
    }
  }
}
